import { render, staticRenderFns } from "./posterForm.vue?vue&type=template&id=3adec462&scoped=true"
import script from "./posterForm.vue?vue&type=script&lang=js"
export * from "./posterForm.vue?vue&type=script&lang=js"
import style0 from "./posterForm.vue?vue&type=style&index=0&id=3adec462&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3adec462",
  null
  
)

export default component.exports